<template>
  <div v-if="product && productPrice">
    <div class="f-col items-start gap-2">
      <template v-if="product.eyebrow">
        <vf-toggletip v-if="product.eyebrow.details">
          <template #trigger>
            <span class="flex items-center gap-1">
              <p v-bind="eyebrowStyle" class="line-clamp-1 eyebrow">
                {{ product.eyebrow.label }}
              </p>
              <vf-icon name="info" />
            </span>
          </template>
          {{ product.eyebrow.details }}
        </vf-toggletip>
        <p v-else-if="product.eyebrow.label" v-bind="eyebrowStyle" class="line-clamp-1 eyebrow">
          {{ product.eyebrow.label }}
        </p>
      </template>
      <h1 v-if="!isElevated" class="elevate-body-1 fw-bold" data-test-id="product-name">
        {{ product.name }}
      </h1>
      <p v-if="product.promoExclusionsMessage" class="elevate-body-4 c-grey-30 dark:c-grey-70">
        {{ product.promoExclusionsMessage }}
      </p>
      <product-reviews-summary v-if="!isElevated" :reviews-data="reviewsData" />
    </div>
    <product-pricing
      class="elevate-body-3 fw-medium not-first:mt-4"
      :currency="product.currency"
      :price="productPrice"
      :show-discount-percentage="$feature.showDiscountPercentageOnCatalog"
      :show-original-price-for-omnibus="$feature.showOmnibusBadgeOnQuickshopAndPDP"
    />
  </div>
</template>

<script lang="ts" setup>
const { eyebrowStyle, product, productPrice, reviewsData } = usePdp()

const isElevated = computed(() => product.value?.elevatedPDPDetails?.enable)
</script>
